import {
  badgeCheckIcon,
  clockIcon,
  membersIcon,
  userRoundCheckIcon,
} from "@/assets/icons";
import { html, LitElement, TemplateResult } from "lit";

export class SbMonitoringCards extends LitElement {
  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  generateBlockProps(
    type:
      | "total-members"
      | "active-members"
      | "pending-invites"
      | "inactive-members",
  ): {
    title: string;
    content: string;
    icon: () => TemplateResult<2>;
  } {
    switch (type) {
      case "total-members":

      case "active-members":
        return {
          title: "Active Members",
          content: "100",
          icon: userRoundCheckIcon,
        };
      case "pending-invites":
        return { title: "Pending Invites", content: "8", icon: clockIcon };
      case "inactive-members":
        return {
          title: "Inactive Members",
          content: "1",
          icon: badgeCheckIcon,
        };
    }
  }

  statisticBlock({
    title,
    content,
    icon,
  }: {
    title: string;
    content: string;
    icon: () => TemplateResult<2>;
  }) {
    return html` <rtg-card>
      <rtg-card-header>
        <div class="sb-statistic-block-header">
          <rtg-typography-muted>${title}</rtg-typography-muted>
          ${icon()}
        </div>
      </rtg-card-header>
      <rtg-card-footer>
        <rtg-typography-h level="h3">${content}</rtg-typography-h>
      </rtg-card-footer>
    </rtg-card>`;
  }

  render() {
    return html`
      <div class="sb-monitoring-cards-container">
        ${this.statisticBlock(this.generateBlockProps("total-members"))}
        ${this.statisticBlock(this.generateBlockProps("active-members"))}
        ${this.statisticBlock(this.generateBlockProps("pending-invites"))}
        ${this.statisticBlock(this.generateBlockProps("inactive-members"))}
      </div>
    `;
  }
}

customElements.define("sb-monitoring-cards", SbMonitoringCards);

declare global {
  interface HTMLElementTagNameMap {
    "sb-monitoring-cards": SbMonitoringCards;
  }
}
